






































import { Component, Vue } from "vue-property-decorator";
import CommonModule, { MediaQueryService } from "@questelservices/common";
import { CommonComponent } from "@questelservices/common-vue";
import { getModule } from "vuex-module-decorators";
import ShowConfirm from '@/components/Common/ShowConfirm.vue';
import AlertDialog from '@/components/Common/AlertDialog.vue';
import SiteFooter from '@/components/Common/SiteFooter.vue';
import { SimpleLayout } from '@questelservices/common-vue';
import VueBase from '@/components/VueBase';
import LayoutWrapper from '@/views/LayoutWrapper.vue';
import { VueConstructor } from 'vue';
import './component-hooks';
import './msedge';
import moment from 'moment';
import { UserService } from "./services/UserService";

const mediaQueryService = new MediaQueryService();

@Component({ components: { CommonComponent, ShowConfirm, SiteFooter, AlertDialog, LayoutWrapper, SimpleLayout } })
export default class App extends VueBase {

  protected commonModule: CommonModule = getModule(CommonModule, this.$store);
  protected screen: any = null;
  protected beforeUnloadTime: number = 0;
  protected gapTime: number = 0;
  protected userService = new UserService();

  protected commonCompentLogEvents(eventName: string, eventDetails: any): void {
    console.warn(`Log event: ${eventName}`);//`
    console.log(eventDetails);
  }

  protected get layoutComponent(): VueConstructor<Vue> {
    return this.isSimpleLayout
      ? SimpleLayout
      : LayoutWrapper;
  }

  protected get backgroundCss(): string[] {
    return this.isLowerEnv ?  ['lower-env-bg-color'] : []
  }

  protected get isSimpleLayout(): boolean {
    return (this.$route.name === 'employee' || this.$route.name === 'login' || this.$route.name === 'NotFound');
  }

  protected created(): void {
    this.screen = this.getScreenSizeInfo();
  }

  protected sessionExpiring(): void {
    this.authorizationModule.setTokenExpiring(true);
  }

  private getScreenSizeInfo(): any {
    let screenSizes: any = mediaQueryService.sizes;
    return {
      isXSmall: screenSizes["screen-x-small"],
      isLarge: screenSizes["screen-large"],
      cssClasses: Object.keys(screenSizes).filter(cl => screenSizes[cl])
    };
  }

  private get isLowerEnv(): boolean {
    let hostname = window.location.hostname;
    return hostname.includes('localhost') || hostname.includes('test') || hostname.includes('uat') || hostname.includes('staging') || hostname.includes('demo');
  }

  private screenSizeChanged(): void {
    this.screen = this.getScreenSizeInfo();
  }

  protected mounted(): void {

    // Add $alert option to use for alert dialogs. There might be a better way to do this.
    Vue.prototype.$alert = (this.$refs.alert as any).open;
    mediaQueryService.subscribe(this.screenSizeChanged);

    // Override all to Json date formats from "YYYY-MM-ddThh:mm:ssZ" to YYYY-MM-ddThh:mm:ss{offset}"
    Date.prototype.toJSON = function(){return moment(this).format()};

    this.$root.$on("login-success", this.handleLoginEventBus);
  }

  async handleLoginEventBus() {
      await this.userService.updateUserCache();
  }

  protected beforeDestroy(): void {
    mediaQueryService.unsubscribe(this.screenSizeChanged);
    this.$root.$off("login-success");
  }

  protected logEvent(eventName: string, eventDetails: any) : void {
    console.warn('EventName: ' + eventName);
    console.warn(eventDetails);
  }

  protected get hideSessionExpirationDialogs(): boolean {
    return this.$route.name === 'login' || this.$route.name === 'employee';
  }

  protected async onSessionExpired(): Promise<void> {
    // By this time the session user token, impersonation token and locale storage has been cleared
  }

  protected beforeMount(): void {
    //This handles when impersonation is active but browser window is closed
    //Closing the browser or being logged out due to inactivity should end the impersonation session.
    window.addEventListener("beforeunload", this.beforeunloadHandler)
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.beforeunloadHandler);
    });

      //this.userService.getLodgeConfig().then((result) => {
      //    this.$store.state.useNewVersion = result.useNewVersion;
      //})
      //.catch();
  }

  protected beforeunloadHandler(): void {
    this.beforeUnloadTime = new Date().getTime();
  }
}
